import { MetaQualityRating } from 'modules/graphql/types/GraphQLTemplate';
import { WHATSAPP_SENDER_RESTRICTED_STATUSES } from 'modules/templateEditor/common/constants';
import { WhatsAppLocaleContent } from 'modules/templateEditor/common/types';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { WhatsAppNegativeTemplateBadge } from './WhatsAppNegativeTemplateBadge';
import { WhatsAppSenderLimitedBadge } from './WhatsAppSenderLimitedBadge';

const BadgeContainer = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
  position: absolute;
  margin-top: ${spacing.quarter};
  margin-right: ${spacing.quarter};
  top: 0;
  right: 0;
  z-index: 1;
`;

type WhatsAppBadgeProps = {
  whatsAppLocaleContent: WhatsAppLocaleContent[];
};

export const WHATS_APP_STATUS_BADGES_TEST_ID = 'whatsapp-status-badges';

export const WhatsAppStatusBadges = ({ whatsAppLocaleContent }: WhatsAppBadgeProps) => {
  const limitedSenders = whatsAppLocaleContent.filter(
    ({ whatsAppSender }) =>
      !!whatsAppSender?.status &&
      WHATSAPP_SENDER_RESTRICTED_STATUSES.includes(whatsAppSender.status) &&
      !!whatsAppSender?.sendLimit,
  );

  const lowQualityLocales = whatsAppLocaleContent.filter(
    ({ qualityRating }) => qualityRating === MetaQualityRating.Low,
  );

  const hasSenderIssues = !!limitedSenders.length;
  const hasTemplateIssues = !!lowQualityLocales.length;

  // no badges needed if no issues
  if (!hasSenderIssues && !hasTemplateIssues) return null;

  return (
    <BadgeContainer data-test={WHATS_APP_STATUS_BADGES_TEST_ID}>
      {/* Send limit badge */}
      {hasSenderIssues && <WhatsAppSenderLimitedBadge limitedSenders={limitedSenders} />}

      {/* Template status badge */}
      {hasTemplateIssues && (
        <WhatsAppNegativeTemplateBadge
          totalLocales={whatsAppLocaleContent.length}
          lowQualityLocales={lowQualityLocales}
        />
      )}
    </BadgeContainer>
  );
};
